import {
  getLeoUuid,
  LeoUUID,
  getObject,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { DeliveryStats, DeliveryStatsDTO } from "./deliveryStats";
/* eslint-disable import/export */
export abstract class GetDeliveryStatsForProjectRPC implements
  LeoRPC<GetDeliveryStatsForProjectRPC.Request, GetDeliveryStatsForProjectRPC.Response, GetDeliveryStatsForProjectRPC.Errors.Errors>
{
  abstract execute(
    request: GetDeliveryStatsForProjectRPC.Request
  ): Promise<LeoRPCResult<GetDeliveryStatsForProjectRPC.Response, GetDeliveryStatsForProjectRPC.Errors.Errors>>;
}

export namespace GetDeliveryStatsForProjectRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    projectId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetDeliveryStatsForProjectRPCRequest: boolean = true;
  
    readonly projectId: LeoUUID;
  
  
    constructor(
    projectId: LeoUUID
    ) {
      this.projectId = projectId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const projectId = getLeoUuid(dto, "projectId", InvalidRequestProjectIdError);
      return new Request(
        projectId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          projectId: this.projectId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetDeliveryStatsForProjectRPC(projectId='${this.projectId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    deliveryStats: DeliveryStatsDTO;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetDeliveryStatsForProjectResponse: boolean = true;
  
    readonly deliveryStats: DeliveryStats;
  
  
    constructor(
    deliveryStats: DeliveryStats
    ) {
      this.deliveryStats = deliveryStats;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const deliveryStats = DeliveryStats.fromDTO(getObject(dto, "deliveryStats", InvalidResponseDeliveryStatsError));
      return new Response(
        deliveryStats
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          deliveryStats: this.deliveryStats.toDTO()
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetDeliveryStatsForProject(deliveryStats='${this.deliveryStats}')`;
  };
  

  export enum RPCError {
    InvalidProjectId = "INVALID_PROJECT_ID"
  }

  export namespace Errors {
    
    export interface InvalidProjectIdDTO {
      code: string;
    }
    
    export class InvalidProjectId extends LeoRPCError<RPCError> {
      readonly isInvalidProjectId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidProjectId;
        super(code);
      }
    
    
      toDTO(): InvalidProjectIdDTO {
        const dto: InvalidProjectIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidProjectId.prototype.toString = function toString(): string {
      return `GetDeliveryStatsForProjectRPC.INVALID_PROJECT_ID()`;
    };
    

    export type Errors = InvalidProjectId;
    export type ErrorsDTO = InvalidProjectIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidProjectId:
          return new InvalidProjectId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestProjectIdError extends GetDeliveryStatsForProjectRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestProjectIdError";
  }
}

export class InvalidResponseDeliveryStatsError extends GetDeliveryStatsForProjectRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseDeliveryStatsError";
  }
}

export class InvalidResponseInvalidProjectIdError extends GetDeliveryStatsForProjectRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidProjectIdError";
  }
}

